import React from "react";
import { Text } from "@chakra-ui/react";
import PageShell from "../layout/PageShell";
import { LogoCatalog } from "./LogoCatalog";

const LogoSettings: React.FC = () => {
  return (
    <PageShell
      title="Logo setting"
      description="Nuage POS logos. Choose a logo on Email Templates or POS Receipt Email."
      wide
    >
      <Text fontSize="sm" color="gray.600" mb={6}>
        Each series has a long form and a square form. Copy a URL here, or choose the logo from the email page that should use it.
      </Text>
      <LogoCatalog />
    </PageShell>
  );
};

export default LogoSettings;
